/**
 * Real write-up from the class, replacing the earlier generic placeholder.
 * Edit `summary` or each ingredient's `note` directly if this needs updating
 * again before/after the fair.
 */
export const SCIENCE_INTRO = {
  heading: 'How does it work?',
  summary:
    'The soap breaks the surface tension by getting between the water ' +
    'molecules. The water rushes to the highest surface tension near the edge ' +
    'of the plate and carries the floating ingredients with it. We used a ' +
    'blanket and help from the family to explain water tension.',
};

/** Keyed by ingredient slug. `note` is optional per-ingredient placeholder text. */
export const SCIENCE_NOTES = {
  cinnamon: '',
  'blue-food-colouring': '',
  oregano: '',
  'baby-powder': '',
  'extra-virgin-olive-oil': '',
  turmeric: '',
  'ground-coffee': '',
  salt: '',
  'tajin-with-lime': '',
  parsley: '',
};

/** Content for the /more-info page — the full science-fair write-up. */
export const HYPOTHESIS =
  'I predict that some ingredients will move a lot when the soap touches the ' +
  'water, while others will only move a little or not at all because they ' +
  'interact with the water differently.';

export const EXPERIMENT_INTRO =
  'To control the experiment we used a clean plate for each ingredient and the ' +
  'same level of water (using a thumb to measure). To ensure we provided the ' +
  'same amount of dishwashing detergent we used a cotton bud.';

export const EXPERIMENT_STEPS = [
  'Wait for the water in the plate to be still.',
  'Add one teaspoon of the ingredient.',
  'Turn on the video',
  'Add the soap',
  'Turn off the video',
];

export const RESULTS_INTRO = 'Hypothesis was correct';

export const RESULTS_TABLE = [
  { ingredient: 'Pepper', result: 'Moved quickly toward the edge of the plate', reaction: '9/10' },
  { ingredient: 'Salt', result: 'Did not float and did not move. Hard to see.', reaction: '0/10' },
  { ingredient: 'Turmeric', result: 'Almost not movement, just a small dot was cleared.', reaction: '1/10' },
  {
    ingredient: 'Cinnamon',
    result: 'Moved almost all the way to the edge of the plate. Stayed close together.',
    reaction: '9/10',
  },
  { ingredient: 'Oregano', result: 'Moved almost all the way to the edge of the plate', reaction: '6/10' },
  { ingredient: 'Parsley', result: 'Moved almost all the way to the edge of the plate', reaction: '8/10' },
  { ingredient: 'Tajín with Lime', result: 'Moved halfway toward the edge of the plate', reaction: '4/10' },
  { ingredient: 'Ground Coffee', result: 'Moved halfway toward the edge of the plate.', reaction: '4/10' },
  {
    ingredient: 'Blue Food Colouring',
    result: 'Some went to the edge of the plate, and some stayed in the middle of the plate.',
    reaction: '6/10',
  },
  {
    ingredient: 'Baby Powder',
    result: "Only moved slightly toward the edge of the plate but didn't reach the edge",
    reaction: '3/10',
  },
  {
    ingredient: 'Extra Virgin Olive Oil',
    result: 'Almost not movement, just a small dot was cleared.',
    reaction: '1/10',
  },
];

export const PRACTICAL_RESEARCH =
  'I started with ground pepper and used my finger to add dishwashing detergent ' +
  'and was amazed by the result the pepper went to the edge of the plate. It ' +
  'was fun and worked well. Then I ran around the house and collected other ' +
  'ingredients like salt, spices, oil and even coffee. I researched by testing ' +
  'different amounts of different ingredients. If I used too much of the ' +
  'ingredients nothing happened. If I used too little it was hard to see the ' +
  'reaction. One teaspoon was the best amount. We needed blue food colouring to ' +
  'see baby powder as it was the same colour as the plate.';
